/** Subconjunto MER usado no filtro “Tipo” da listagem (valores enviados à API). */
export const TIPO_IMOVEL_FILTER_MER_CODES = [
  'APARTAMENTO',
  'CASA',
  'TERRENO_URBANO',
  'SALA_COMERCIAL',
  'GALPAO',
  'FLAT',
] as const;

/** Opções do select: value = código MER, label = PT-BR. */
export function tipoImovelFilterOptions(): Array<{ value: string; label: string }> {
  return [
    { value: 'Todos', label: 'Todos' },
    ...TIPO_IMOVEL_FILTER_MER_CODES.map((code) => ({
      value: code,
      label: labelTipoImovelApi(code),
    })),
  ];
}

/** Rótulos PT-BR para valores MER `TipoImovel` (espelha BE `labelTipoImovel`). */
const LABELS: Record<string, string> = {
  CASA: 'Casa',
  APARTAMENTO: 'Apartamento',
  SOBRADO: 'Sobrado',
  CASA_DE_CONDOMINIO: 'Casa de condomínio',
  FLAT: 'Flat',
  LOFT: 'Loft',
  SALA_COMERCIAL: 'Sala comercial',
  LOJA: 'Loja',
  GALPAO: 'Galpão',
  PREDIO_COMERCIAL: 'Prédio comercial',
  CHACARA: 'Chácara',
  SITIO: 'Sítio',
  FAZENDA: 'Fazenda',
  LOTE: 'Lote',
  GLEBA: 'Gleba',
  TERRENO_URBANO: 'Terreno urbano',
  VAGA_DE_GARAGEM: 'Vaga de garagem',
};

export function labelTipoImovelApi(code: string | null | undefined): string {
  if (!code?.trim()) return '—';
  return (
    LABELS[code] ??
    code
      .replace(/_/g, ' ')
      .toLowerCase()
      .replace(/\b\w/g, (c) => c.toUpperCase())
  );
}

/** Exibe enum MER `Modalidade` (underscores → espaços). */
export function labelModalidadeMer(code: string | null | undefined): string {
  if (!code?.trim()) return '';
  return code.replace(/_/g, ' ');
}
